export const toFixedFloor = (value, precision) => {
  const regex = new RegExp(`^-?\\d+(?:\\.\\d{0,${precision}})?`);

  return parseFloat(value.toString().match(regex)[0]);
};

// find the greatest common divsior from array
export const getGCDFromArray = (numbers) => {
  const a = numbers[0];
  const b = numbers[1];

  if (!b) {
    return a;
  }

  const slicedNumbers = numbers.slice(2);
  const modNumber = a % b;
  const newNumbers = modNumber ? [b, modNumber, ...slicedNumbers] : [b, ...slicedNumbers];

  return getGCDFromArray(newNumbers);
};

export const fitToRange = (value, min, max) => {
  if (value > max) return max;
  if (value < min) return min;

  return value;
};

export const padWithZeros = (value, digitCount) => value.toString().padStart(digitCount, '0');
